module.exports = __webpack_public_path__ + "assets/img/gameImg.8943823e.png";